import { Link } from "react-router";
import { cn } from "@/lib/utils";
import logoLarge from "@/assets/open-volify-logo-large.png";

export function TopNav() {
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-24 items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={logoLarge} alt="OpenVolify" className="h-10 w-auto" />
          </Link>
          <div className="flex items-center gap-6">
            <Link
              to="/product"
              className={cn(
                "text-md font-medium transition-colors hover:text-foreground",
                isActive("/product") ? "text-foreground" : "text-muted-foreground",
              )}
            >
              Platform
            </Link>
            <Link
              to="/about"
              className={cn(
                "text-md font-medium transition-colors hover:text-foreground",
                isActive("/about") ? "text-foreground" : "text-muted-foreground",
              )}
            >
              About
            </Link>
            <Link
              to="/community"
              className={cn(
                "text-md font-medium transition-colors hover:text-foreground",
                isActive("/community") ? "text-foreground" : "text-muted-foreground",
              )}
            >
              Community
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
